import Transformer from './../transformer'
import secondContactTransformer from './secondContact'

export default class AffectedTransformer extends Transformer {
  static fetch(contact) {
    const secondAddress = contact.profile.address[1] ?
      secondContactTransformer.fetch(contact.profile.address[1]) :
      {} 
    return {
      contact: contact.name,
      cellphone: contact.profile.cellphone,
      phone: contact.profile.phone,
      phoneExt: contact.profile.phone_ext,
      alternativeEmail: contact.profile.alternative_email,
      address: {
        id: contact.profile.address[0].id,
        state: contact.profile.address[0].state,
        municipality: contact.profile.address[0].municipality,
        street: contact.profile.address[0].street,
        noExt: contact.profile.address[0].no_ext,
        colony: contact.profile.address[0].colony,
        postalCode: contact.profile.address[0].postal_code,
      },
      secondAddress,
    }
  }
}


// WEBPACK FOOTER //
// ./src/transformers/provider/contact.js